import React from "react";
import { useEffect } from "react";

function Contact() {
    useEffect(() => {
        window.scrollTo(0,0)
    },[])
    return (
        <div className="contact-content">
            <div className="whatIDo contact-div">
                <p className="grey-note">WANT TO CONNECT?</p>
                <div className="grey-line"></div>
                <form className="contact-form pageclip-form" action="https://send.pageclip.co/8Atc6bEDDyY9W02GHyO9HTXy3mrVEkDV" method="post">
                    <div className="contact-element">
                        <input placeholder="Your Name" name="name" />
                    </div>
                    <div className="contact-element">
                        <input placeholder="Your Email" name="email"/>
                    </div>
                    <div className="contact-element">
                        <textarea placeholder="Your Message" name="message"/>
                    </div>
                    <input type="submit" className="pageclip-form__submit" value="Submit Message" />
                </form>
            </div>
        </div>
        
    );
};

export default Contact;